import { type MatrixOffers } from '@vakantiesnl/services/src/hooks/queries/packageOffers/useGetDepartureDateMatrixOffers';
import { type OfferItem } from '@vakantiesnl/types/src/search';

export function findCheapestOffer(matrixOffers: MatrixOffers): OfferItem | null {
	let cheapestOffer: OfferItem | null = null;

	for (const offers of Object.values(matrixOffers)) {
		for (const offer of offers) {
			if (!offer) {
				continue;
			}
			if (!cheapestOffer) {
				cheapestOffer = offer;
			}
			if (offer.priceTotal < cheapestOffer.priceTotal) {
				cheapestOffer = offer;
			}
		}
	}

	return cheapestOffer;
}
